// Pure, DOM-free shape decision, kept out of about_component_controller.js so a plain
// `node --test` run can import it without Stimulus.
//
// Mirrors the responsive-behavior spec's own algorithm: measure the rendered (hidden, natural-
// width) content, never guess from a fixed breakpoint. cellCount is the number of stats actually
// visible (1-3, depending on hide_content_counts/hide_content_duration and zero counts) — the
// stacked-fit divisor scales with it, it is never a hardcoded 3. columnGap is the stacked grid's
// own gap between cells: three cells share the container minus two gaps, not the whole of it.
export function chooseStatsShape({
  containerWidth,
  naturalRowWidth,
  widestCellNaturalWidth,
  cellCount,
  columnGap = 0,
}) {
  if (naturalRowWidth <= containerWidth) return 'inline'

  const cellWidth = (containerWidth - columnGap * (cellCount - 1)) / cellCount
  if (widestCellNaturalWidth <= cellWidth) return 'stacked'

  return 'rows'
}
